module.exports = __webpack_public_path__ + "img/ds1.5d16c43c.png";